import Vue from "vue";

export async function fetchSections({ commit }) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/sections`,
    });
    return data
  } catch (e) {
    return e
  } finally {}
}